import * as Sentry from '@sentry/gatsby';

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN_URL,
  environment: process.env.NODE_ENV,
  enabled: !!process.env.GATSBY_SENTRY_DSN_URL && process.env.NODE_ENV === 'production',
  beforeSend(event, hint) {
    // This is where we can filter events

    const error = hint?.originalException;
    if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
      // Filter out React hydration errors
      if (
        error.message.match(/Minified React error #423/i) ||
        error.message.match(/Minified React error #418/i)
      ) {
        return null;
      }
      // Filter out DOM manipulation errors caused by browser extensions/iOS Chrome
      // modifying React-managed DOM (NotFoundError from insertBefore)
      if (error.message.match(/The object can not be found here/i)) {
        return null;
      }
    }
    return event;
  },
});
